import { render } from "./ad.vue?vue&type=template&id=2a6b0c47"
import script from "./ad.vue?vue&type=script&lang=js"
export * from "./ad.vue?vue&type=script&lang=js"

import "./ad.vue?vue&type=style&index=0&id=2a6b0c47&lang=scss&Scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__